import { WEATHER_STORE } from "@/store/store";
import { WeatherDispatch } from "@/store/type";
import { useDispatch } from "@wordpress/data";
import { useTranslation } from "react-i18next";

import "./style.scss";

type PrevisionButtonProps = {
	selectedDate: Date;
	setDate: (date: Date) => void;
};

export const PrevisionButton = ({
	selectedDate,
	setDate,
}: PrevisionButtonProps) => {
	const { t } = useTranslation();
	const currentDate = new Date().getDate();
	const { setNewDatePrevision, setPrevisionDateCard } = useDispatch(
		WEATHER_STORE,
	) as WeatherDispatch;

	const handleChangeDate = (action: "today" | "tomorrow") => {
		let newDate: Date;

		if (action === "today") {
			newDate = new Date(selectedDate);
			newDate.setDate(newDate.getDate() - 1);

			setPrevisionDateCard({
				type: "weather",
				date: newDate,
			});
		} else {
			newDate = new Date(selectedDate);
			newDate.setDate(newDate.getDate() + 1);

			setPrevisionDateCard({
				type: "weather",
				date: selectedDate,
			});
		}

		setDate(newDate);
		setNewDatePrevision(newDate);
	};

	return (
		<div className="prevision-button-table">
			<button
				onClick={() => handleChangeDate("today")}
				className={`${selectedDate.getDate() === currentDate && "active"}`}
				disabled={selectedDate.getDate() === currentDate}
			>
				{t("today")}
			</button>
			<button
				className={`${selectedDate.getDate() === currentDate + 1 && "active"}`}
				onClick={() => handleChangeDate("tomorrow")}
				disabled={selectedDate.getDate() === currentDate + 1}
			>
				{t("tomorrow")}
			</button>
		</div>
	);
};

export default PrevisionButton;
